export const defaultChartOptions = {
    chart: {
    },
    title: {
        text: null//'Solar Employment Growth by Sector, 2010-2016'
    }
}

export default defaultChartOptions
